import {useEffect} from 'react';
import {LayerGroup, useMap} from 'react-leaflet';
import {UiLocationActions, useUiContext} from 'src/context/UiContext';
import {Location} from 'src/services/api/types/types';
import {LocationMarker} from '../marker/LocationMarker';
import {LatLngExpression} from 'leaflet';

interface VisibleLocationsLayerProps {
    locations: Array<Location>;
    reasonQuery: string;
}

export function VisibleLocationsLayer({locations, reasonQuery}: VisibleLocationsLayerProps) {
    const map = useMap();
    const {state, dispatch} = useUiContext();

    useEffect(() => {
        let debouncedUpdateVisibles: NodeJS.Timeout;
        const updateVisibles = () => {
            clearTimeout(debouncedUpdateVisibles);
            debouncedUpdateVisibles = setTimeout(() => {
                dispatch({
                    type: UiLocationActions.SET_VISIBLE_LOCATIONS,
                    value: locations.filter(({id, position}) => {
                        const l = {
                            lat: position.lat,
                            lng: position.lon
                        } as LatLngExpression;
                        const isVisibleOnMap = map.getBounds().contains(l);
                        const isOpenPopup = state.popupOpenId?.type === 'LOCATION' && id === state.popupOpenId.id;
                        return isVisibleOnMap || isOpenPopup;
                    })
                });
            }, 100);
        };

        map.on('moveend', updateVisibles);
        updateVisibles();

        return () => {
            clearTimeout(debouncedUpdateVisibles);
            map.off('moveend', updateVisibles);
        };
    }, [locations, dispatch, map, state.popupOpenId]);

    return (
        <LayerGroup>
            {state.visibleLocations.length > 0 &&
                state.visibleLocations.map((location) => {
                    return (
                        <LocationMarker
                            key={location.id}
                            position={{lat: location.position.lat, lng: location.position.lon}}
                            location={location}
                            zoomLevel={map.getZoom()}
                        />
                    );
                })}
        </LayerGroup>
    );
}
